import { render, staticRenderFns } from "./sellList.vue?vue&type=template&id=89996852&scoped=true&"
import script from "./sellList.vue?vue&type=script&lang=js&"
export * from "./sellList.vue?vue&type=script&lang=js&"
import style0 from "./sellList.vue?vue&type=style&index=0&id=89996852&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89996852",
  null
  
)

export default component.exports